module.exports = __webpack_public_path__ + "static/media/img128_R.f11a7678.jpg";